import { atom } from "recoil";
const date = new Date();
 const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
const formattedDate = `${day} ${month} ${year}`;
const goDateState =atom({
    key: 'goDate',
    default: formattedDate
})

export default goDateState